import { combineReducers } from "redux";
import { reducer as reduxForm } from "redux-form";
import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore';

import authReducer from "./authReducer";
import campaignReducer from "./campaignReducer";
import recipientReducer from "./recipientReducer";
import settingsReducer from "./settingReducer";

export default combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  auth: authReducer,
  form: reduxForm,
  campaigns: campaignReducer,
  recipients: recipientReducer,
  settings: settingsReducer
});
